<template>
  <transition name="fade" mode="out-in" @after-enter="$emit('transitionEnd', this)">
    <div v-if="loadingText && isLoading">
      <yz-spinner key="spinner" color="#1b90f5" class="center" />
      <p class="text-center" v-if="loadingText">{{ loadingText }}</p>
    </div>
    <yz-spinner v-else-if="isLoading" key="spinner" color="#1b90f5" class="centered" />

    <div class="error-container text-center" v-else-if="showError && task.error">
      <h2 class="title">{{ $t('errorView.title') }}</h2>
      <article class="content">
        <p>{{ errorMessage }}</p>
        <p class="small" v-if="canRetry"><a href="#" @click.prevent.stop="retry">{{ $t('errorView.tryAgain') }}</a></p>
      </article>
    </div>

    <div key="main" v-else-if="$slots.default">
      <slot></slot>
    </div>
    <slot name="root" v-else-if="$slots.root"></slot>
  </transition>
</template>

<script>
  export default {
    props: {
      task: {
        type: Object,
        required: true
      },
      autoRun: {
        type: Boolean,
        default: true
      },
      canRetry: {
        type: Boolean,
        default: true
      },
      showError: {
        type: Boolean,
        default: true
      },
      loadingText: String,
      errorText: String
    },

    beforeMount () {
      if (this.autoRun) {
        this.task.perform()
      }
    },

    computed: {
      isLoading () {
        return this.task.isRunning
      },

      errorMessage () {
        return this.errorText || this.$t('failedLoadingData')
      }
    },

    methods: {
      retry () {
        return this.task.perform()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TaskLoading.vue?068ddfb1